<template>
  <div class="main-content">
    <div class="return">
      <a href="#" onclick="history.go(-1);">
        <BaseIcon size="24" name="trending_flat" />
        Wróć
      </a>
    </div>
    <img class="image" src="@/assets/img/404_white.png">
    <a href="https://kcalmar.com/dietetyk/" class="dashboard-link">www.kcalmar.pro</a>
  </div>
</template>

<script lang="ts" setup>
  import BaseIcon from '@/components/BaseIcon.vue'
</script>

<style scoped>
  .main-content {
    text-align: center;
    background-color: #fff;
  }

  .dashboard-link {
    display: block;
    margin-top: 10px;
    font-family: Montserrat-Medium;
    font-size: 22px;
    color: #20dec1;
    text-align: center;
  }

  .return {
    margin: 40px 0 0 40px;
  }

  .return a {
    display: flex;
    align-items: center;
    font-family: Montserrat-Medium;
    font-size: 14px;
    color: #8d95a5;
    text-transform: uppercase;
    text-decoration: none;
    transition: all 0.2s;
  }

  .return a :deep(.base-icon) {
    transform: rotate(180deg);
  }

  .return a:hover,
  .return a:hover :deep(.base-icon) i {
    color: var(--color-main-110);
  }

  .image {
    max-width: 100%;
    margin-top: 60px;
  }
</style>
